// Obtient l'élément suivant ou le premier si aucun suivant n'existe
function getNextOrFirst(element) {
    const next = element.nextElementSibling;
    if (next) {
        return next;
    }
    return element.parentNode.firstElementChild;
}

// Carrousel des produits en vedette de la page d'accueil
const homeFeaturedProductsItems = document.querySelectorAll('#home-carousel .carousel-item');
if (homeFeaturedProductsItems.length > 0) {
    homeFeaturedProductsItems.forEach((item) => {
        const next = getNextOrFirst(item);

        const firstChild = next.firstElementChild;
        if (firstChild) {
            const clone = firstChild.cloneNode(true);
            item.appendChild(clone);
        }

        if (homeFeaturedProductsItems.length > 2) {
            const nextNext = next.nextElementSibling;
            if (nextNext) {
                const secondChild = nextNext.firstElementChild;
                if (secondChild) {
                    const clone = secondChild.cloneNode(true);
                    item.appendChild(clone);
                }
            } else {
                const firstSibling = item.parentNode.firstElementChild;
                if (firstSibling && firstSibling.firstElementChild) {
                    const clone = firstSibling.firstElementChild.cloneNode(true);
                    item.appendChild(clone);
                }
            }
        }
    });
}

// Carrousel à trois éléments
const threeItemCarousels = document.querySelectorAll('.three-item-carousel');
threeItemCarousels.forEach((carousel) => {
    const carouselItems = carousel.querySelectorAll('.carousel-item');

    carouselItems.forEach((item) => {
        let next = getNextOrFirst(item);

        const firstChild = next.firstElementChild;
        if (firstChild) {
            const clone = firstChild.cloneNode(true);
            item.appendChild(clone);
        }

        for (let i = 0; i < 3; i++) {
            next = getNextOrFirst(next);
            const childToClone = next.firstElementChild;
            if (childToClone) {
                const clone = childToClone.cloneNode(true);
                item.appendChild(clone);
            }
        }
    });
});
